import { Injectable } from "@angular/core";
import { BaseClientService } from "./base-client.service";
import { PaisDetaild } from "../../interface/pais-detaild";

@Injectable({
  providedIn: "root",
})
export class PaisService {
  constructor(private client: BaseClientService) {}

  async getPaisByCode(code: string) {
    return await this.client.get<PaisDetaild>(`/pais/${code}`).toPromise();
  }
}
